module.exports = [{"code":1,"name":"企业车辆"},{"code":2,"name":"临时车辆"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/fromCar.json
// module id = DSG0
// module chunks = 11